module.exports = __webpack_public_path__ + "static/media/pc4.3ff6a48f.png";